var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2"},[_c('b-button',{staticClass:"shadow",attrs:{"variant":"primary","to":"/bpj/new"}},[_c('font-awesome-icon',{attrs:{"icon":"plus-square"}}),_vm._v(" Input BPJ\n        ")],1)],1),_vm._v(" "),_c('paginated-browser',{ref:"browserBpj",attrs:{"data-callback":_vm.getBpj},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var pagination = ref.pagination;
return [_c('table-bpj',{attrs:{"items":data},on:{"deleteBpj":_vm.deleteBpj}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758a46b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrowseBpj.vue
// module id = null
// module chunks = 